// extracted by mini-css-extract-plugin
module.exports = {"title":"AddTransactionModal_title__3iic0"};